/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pb_Publish_TitleInputs */

const en_pb_publish_title = /** @type {(inputs: Pb_Publish_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share a playbook`)
};

const id_pb_publish_title = /** @type {(inputs: Pb_Publish_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagikan playbook`)
};

/**
* | output |
* | --- |
* | "Share a playbook" |
*
* @param {Pb_Publish_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pb_publish_title = /** @type {((inputs?: Pb_Publish_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pb_Publish_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pb_publish_title(inputs)
	return en_pb_publish_title(inputs)
});